// extracted by mini-css-extract-plugin
export var dataCell = "_qy-2";
export var dataRow = "_qy-0";
export var headerRow = "_qy-1";